/* eslint-disable no-console */

import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      console.log('Service worker is ready.')
    },
    registered () {
      console.log('Service worker has been registered.')
    },
    cached () {
      console.log('Service worker has cached the files.')
    },
    updatefound () {
      console.log('Update found for the service worker.')
    },
    updated () {
      console.log('Service worker has been updated.');
      // Reload the page to get the latest assets
      window.location.reload();
    },
    offline () {
      console.log('You are offline, service worker is running from cache.');
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}

const CACHE_NAME = "my-app-cache-v1"; // Change version to force updates

self.addEventListener("install", () => {
  // Skip waiting to immediately activate the new service worker
  self.skipWaiting();
});

self.addEventListener("activate", (event) => {
  event.waitUntil(
    caches.keys().then((cacheNames) => {
      return Promise.all(
        cacheNames.map((cache) => {
          if (cache !== CACHE_NAME) {
            console.log("Deleting old cache:", cache);
            return caches.delete(cache);
          }
        })
      );
    })
  );
  self.clients.claim(); // Forces new service worker to take control immediately
});

self.addEventListener("fetch", (event) => {
  if (event.request.mode === "navigate") {
    // Always fetch the latest index.html from the network
    event.respondWith(
      fetch(event.request).catch(() => caches.match(event.request))
    );
  } else {
    event.respondWith(
      caches.match(event.request).then((response) => {
        return response || fetch(event.request);
      })
    );
  }
});